/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import DatePicker from 'rsuite/DatePicker';

import { shouldDisableDate } from 'src/utils/common';

type DatePickerType = {
  value: any;
  onChange: (e: any) => void;
  onKeyDown?: (e: any) => void;
  handleClose?: () => void;
  placeholder?: string;
  disabled?: boolean;
  container?: any;
  customDatePicker?: boolean;
};

function DateOfBirthPicker({
  value,
  onChange,
  handleClose,
  placeholder,
  disabled,
  container,
  onKeyDown,
  customDatePicker,
}: DatePickerType) {
  //to close date picker on scroll
  const datePickerRef = useRef<any>();

  const parsedValue = React.useMemo(() => {
    if (!value) return null;

    if (value instanceof Date) return value;

    const date = new Date(value);

    return isNaN(date.getTime()) ? null : date;
  }, [value]);

  useEffect(() => {
    const handleScroll = () => {
      if (container && container?.current && datePickerRef?.current) {
        datePickerRef?.current.close();
      }
    };

    if (container && container?.current) {
      container?.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container && container?.current) {
        container?.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div
      className="relative [&>*]:w-full"
      onKeyDown={e => onKeyDown && onKeyDown(e)}
    >
      <DatePicker
        onChange={e => {
          if (!e) {
            onChange(null);
            return;
          }
          if (
            e instanceof Date &&
            !isNaN(e.getTime()) &&
            !shouldDisableDate(e)
          ) {
            onChange(e);
          }
        }}
        onBlur={e => {
          const input = e.target as HTMLInputElement;
          if (!input.value) return;
          const parsedDate = new Date(input.value);
          if (isNaN(parsedDate.getTime()) || shouldDisableDate(parsedDate)) {
            onChange(null);
          }
        }}
        value={parsedValue}
        format="MM/dd/yyyy"
        shouldDisableDate={shouldDisableDate}
        onClose={() => {
          handleClose && handleClose();
        }}
        disabled={disabled}
        placeholder="mm/dd/yyyy"
        ref={datePickerRef}
        placement="autoVerticalStart"
        cleanable={disabled ? false : true}
        className={customDatePicker ? 'custom-date-picker' : ''}
      />
    </div>
  );
}
export { DateOfBirthPicker };
